import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Statistics } from "@app/core/statistics/domain/model/statistics";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { Injectable } from "@angular/core";
import { StatisticsMapper } from "@app/core/statistics/data/network/mapper/statistics.mapper";
import { StatisticsSearchCriteria } from "@app/core/statistics/domain/statistics-search-criteria";
import { StatisticsSearchCriteriaMapper } from "@app/core/statistics/data/network/statistics-search-criteria.mapper";

/**
 * Web service to get the general statistics of the user.
 */
@Injectable({
  providedIn: "root",
})
export class AggregateStatisticsWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(
    statisticsSearchCriteria: StatisticsSearchCriteria,
    token: string
  ): Observable<Statistics> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.get)
      .setUrl(ApiUrls.AGGREGATE_STATISTICS_ENDPOINT())
      .setAuthorization(new TokenAuthorization(token))
      .setUrlParams(
        // It is necessary to serialize to put the parameters in such a way that the API accepts them
        StatisticsSearchCriteriaMapper.serialize(statisticsSearchCriteria)
      )
      .build();
    return this.baseHandler
      .execute(parameters)
      .pipe(map((response) => StatisticsMapper.deserialize(response)));
  }
}
